import { _UserData } from 'base/src/infra/storage/localStorage';
import Avatar from 'base/src/components/Avatar';

import * as S from './styles'

import { Tag } from 'base/src/components/Tag';
import { formatDate } from 'base/src/utils/stringUtil';
import { CampanhaPedidoResgateResponse } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse';

import { useCallback, useEffect, useState } from 'react';

import { Options } from 'base/src/components/Options';
import StateMensage from 'base/src/view/states/state';

import { Button } from 'base/src/components/Button';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { ModalTrigger } from 'base/src/components/Modal';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { Icon } from '@iconify/react';
import { CAMPANHARESGATE_APROVAR } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgate';
import { CampanhaUsuarioResponse } from '../../../../types/campanhaUsuario/campanhaUsuarioResponse';
import { CampanhaPedidoExtratoResponse } from '../../../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse';
import AprovarPedidoDetalhesContainer from '../../../../containers/aprovarPedido/aprovarPedidoDetalhes/aprovarPedidoDetalhesContainer';
import { RootStateCampanha } from '../../../../store/campanhaReducer';
import { AprovarResgate } from '../../../../store/aprovarPedido/actions/aprovarPedidoAction';

const connector = connectUtil(
  (_state: RootStateCampanha) => ({
    teste: _state.AprovarPedidoReducer.mudancaStatus
  }),
  { AprovarResgate }
);

export interface AprovarPedidoDetalhesProps extends PropsFromRedux<typeof connector> {
  campanhaPedidoResgate: CampanhaPedidoResgateResponse;
  onClose: () => void;
}

function AprovarPedidoDetalhes(props: AprovarPedidoDetalhesProps) {
  const _aprovarPedidoContainer = new AprovarPedidoDetalhesContainer(props)

  const [status, setStatus] = useState<number>(0);
  const [campanhaUsuario, setCampanhaUsuario] = useState<CampanhaUsuarioResponse | null>(null);
  const [campanhaPedidoExtrato, setCampanhaPedidoExtrato] = useState<CampanhaPedidoExtratoResponse[]>([]);
  const [isExtratoExpanded, setIsExtratoExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID) {
      // Buscar dados do usuário na campanha
      _aprovarPedidoContainer.GetCampanhaUsuario(props.campanhaPedidoResgate._Usuario.UsuarioID, props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID).then((response) => {
        setCampanhaUsuario(response);
      });

      // Buscar extrato do usuário na campanha
      _aprovarPedidoContainer.GetCampanhaPedidoExtrato(props.campanhaPedidoResgate._Usuario.UsuarioID, props.campanhaPedidoResgate.Premiacao.Campanha.CampanhaID).then((response) => {
        setCampanhaPedidoExtrato(response);
      });
    }
  }, [props.campanhaPedidoResgate]);


  const _userData = _UserData;

  const invalidTransitions = new Set([
    "1-1", "1-4", "1-5", "1-7", "1-8",
    "2-2", "2-4", "2-5", "2-7", "2-8",
    "3-1", "3-2", "3-3", "3-4", "3-5", "3-6", "3-7", "3-8",
    "4-1", "4-2", "4-3", "4-4", "4-5", "4-6", "4-7", "4-8",
    "5-1", "5-2", "5-3", "5-4", "5-5", "5-6", "5-7", "5-8",
    "6-1", "6-2", "6-3", "6-4", "6-5", "6-6", "6-7", "6-8",
    "7-1", "7-2", "7-3", "7-4", "7-5", "7-6", "7-7", "7-8",
    "8-1", "8-2", "8-3", "8-4", "8-5", "8-6", "8-7", "8-8"
  ]);

  function getFilteredOptions(currentStatus: number) {
    return [
      {
        nomeGrupo: "Selecionar status",
        options: [
          { id: 1, nome: "Solicitado" },
          { id: 2, nome: "Aprovado" },
          { id: 3, nome: "Não Aprovada" },
          { id: 4, nome: "Pago/Entregue" },
          { id: 5, nome: "Em Espera" },
          { id: 6, nome: "Cancelado" },
          { id: 7, nome: "Lote Alocado" },
          { id: 8, nome: "Erro no Pagamento" },
        ].filter(opt => !invalidTransitions.has(`${currentStatus}-${opt.id}`))
      }
    ];
  }

  const handleChangeStatus = useCallback(
    async () => {
      await props.AprovarResgate(
        props.campanhaPedidoResgate.CampanhaPedidoResgateID,
        props.campanhaPedidoResgate.CampanhaPedidoResgateStatusID,
        Number(status)
      );

      // Limpar estado antes de fechar
      setStatus(0);
      setIsExtratoExpanded(false);

      props.onClose();
    },
    [props.campanhaPedidoResgate, _userData, props.AprovarResgate, status, props.onClose]
  );

  const filteredOpts = getFilteredOptions(props.campanhaPedidoResgate.CampanhaPedidoResgateStatusID);


  function optionOnChange(v: string) {
    setStatus(Number(v))
  }


  function handleClose() {
    // Limpar qualquer estado local antes de fechar
    setStatus(0);
    setIsExtratoExpanded(false);

    // Chamar a função de fechamento da modal
    props.onClose();
  }

  function toggleExtratoVisibility() {
    setIsExtratoExpanded(!isExtratoExpanded);
  }

  const statusA = props.campanhaPedidoResgate.CampanhaPedidoResgateStatus;
  const statusID = statusA?.CampanhaPedidoResgateStatusID;
  return (
    <S.Container>
      <S.ScrollableContent>
        <S.Title>Resgate</S.Title>
        <S.AvatarContainer>
          {props.campanhaPedidoResgate.CampanhaPedidoResgateStatus &&
            <Tag
              variant={
                statusID === 1 || statusID === 5
                  ? 'warning'
                  : statusID === 2 || statusID === 4
                    ? 'positive'
                    : statusID === 3 || statusID === 6
                      ? 'danger'
                      : 'positive'
              }
            >
              {props.campanhaPedidoResgate.CampanhaPedidoResgateStatus.Titulo}
            </Tag>
          }

          <S.ProfileInfo>
            <Avatar size='md' alt='asdasd' fallBack='ss' borderColor='transparent' src={props.campanhaPedidoResgate._Usuario.ImagemUrl} />
            <S.TextCotainer>
              <S.Title>{props.campanhaPedidoResgate._Usuario.NomeCompleto}</S.Title>
              {campanhaUsuario?.EmAnalise && (
                <div style={{ marginTop: 5 }}>
                  <Tag variant='danger'>
                    Usuário Suspeito
                  </Tag>
                </div>
              )}
            </S.TextCotainer>
          </S.ProfileInfo>
        </S.AvatarContainer>
        <S.PremiacaoInfo>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <S.PremiacaoImagem src={props.campanhaPedidoResgate.Premiacao.ImagemUrl} alt="" />
            <S.TextCotainer>
              <S.Text>{props.campanhaPedidoResgate.Premiacao.Titulo}</S.Text>
              <S.Subtitle>{props.campanhaPedidoResgate.Premiacao.Descricao}</S.Subtitle>
            </S.TextCotainer>
          </div>
          <S.ValorContainer>
            <S.Text>{props.campanhaPedidoResgate.Qtde}</S.Text>
            x
            <S.Text>{formatToBRL(props.campanhaPedidoResgate.Premiacao.ValorMonetario ?? props.campanhaPedidoResgate.Premiacao.Valor)}</S.Text>
          </S.ValorContainer>
        </S.PremiacaoInfo>
        <div style={{ paddingBlock: 20 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {
              statusID === 1 ?
                <S.Text>Este resgate ainda não passou por aprovação. Deseja aprovar o resgate?</S.Text>
                :
                statusID === 5 ?
                  <></>
                  :
                  <S.Text>Mude o status do resgate:</S.Text>
            }
            {
              statusID === 5 ?
                <S.Text>Este resgate está em espera do processamento...</S.Text>
                :
                <div style={{ width: 150 }}>
                  <Options
                    full
                    name="SelecionarStatus"
                    onChangeValue={optionOnChange}
                    placeholder="Selecionar status"
                    optionsGroup={filteredOpts}
                    insideModal={true}
                  />
                </div>
            }
          </div>
        </div>

        {/* Informações do Usuário */}
        <S.UserInfoHeader>
          <S.Title>Informações do Usuário</S.Title>
          {campanhaUsuario?.EmAnalise ? (
            <Tag variant='danger'>
              ⚠️ Usuário marcado como suspeito
            </Tag>
          ) : campanhaUsuario && (
            <Tag variant='positive'>
              ✓ Usuário com perfil regular
            </Tag>
          )}
        </S.UserInfoHeader>

        {/* Botão para expandir/colapsar extrato */}
        {campanhaPedidoExtrato.length > 0 && (
          <S.ExtratoToggleButton
            onClick={toggleExtratoVisibility}
            data-expanded={isExtratoExpanded}
          >
            <Icon icon="ph:caret-right" width={16} />
            <span>
              {isExtratoExpanded ? 'Ocultar' : 'Ver'} Extrato do Usuário na Campanha ({campanhaPedidoExtrato.length} itens)
            </span>
          </S.ExtratoToggleButton>
        )}

        {/* Extrato do Usuário - Expandível */}
        {campanhaPedidoExtrato.length > 0 && isExtratoExpanded && (
          <S.ExtratoContainer>
            <S.ExtratoList>
              {campanhaPedidoExtrato.slice(0, 5).map((item, index, array) => (
                <S.ExtratoItem key={item.ExtratoID} isLast={index === array.length - 1}>
                  <S.ExtratoItemInfo>
                    <S.Text>{item.Descricao}</S.Text>
                    <S.ExtratoDate>{formatDate(item.Data)}</S.ExtratoDate>
                  </S.ExtratoItemInfo>
                  <S.ExtratoItemValue>
                    <S.ExtratoPoints isPositive={true}>
                      {item.Pontuacao}
                    </S.ExtratoPoints>
                    <S.Subtitle>pts</S.Subtitle>
                  </S.ExtratoItemValue>
                </S.ExtratoItem>
              ))}
            </S.ExtratoList>
          </S.ExtratoContainer>
        )}

        <S.Title>Resumo do Pedido</S.Title>
        <S.PremiacaoInfo>
          <S.Text>Data de Solicitação:</S.Text>
          <S.Text>{formatDate(props.campanhaPedidoResgate.HoraPedido)}</S.Text>
        </S.PremiacaoInfo>
        <S.PremiacaoInfo>
          <S.Text>Item:</S.Text>
          <S.Text>{props.campanhaPedidoResgate.Premiacao.Titulo}</S.Text>
        </S.PremiacaoInfo>
        <S.ValueInfo data-type='original'>
          <S.Text>Valor Pedido:</S.Text>
          <S.Text>{formatToBRL(props.campanhaPedidoResgate.ValorOriginal)}</S.Text>
        </S.ValueInfo>
        <S.ValueInfo data-type='tax'>
          <S.Text>Valor Taxa:</S.Text>
          <S.Text>{formatToBRL(props.campanhaPedidoResgate.ValorTaxa)}</S.Text>
        </S.ValueInfo>
        <S.ValueInfo data-type='total'>
          <S.Text>Valor Total:</S.Text>
          <S.Text>{formatToBRL(props.campanhaPedidoResgate.ValorTotal)}</S.Text>
        </S.ValueInfo>
      </S.ScrollableContent>

      <S.FixedFooter>
        <ModalTrigger asChild>
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 10 }}>
            <Button full variant='secondary' size='md' onClick={handleClose}>Cancelar</Button>
            <Button full variant='primary' size='md' disabled={status == 0 ? true : false} onClick={handleChangeStatus}>Salvar</Button>
          </div>
        </ModalTrigger>
        <StateMensage stateLoadingNames={[CAMPANHARESGATE_APROVAR]} stateErrorNames={[CAMPANHARESGATE_APROVAR]} />
      </S.FixedFooter>
    </S.Container>
  )
}

export default connector(AprovarPedidoDetalhes);